import React from 'react';
import { ParameterType, Type } from '../apiref/apireftypes';
import { ApiRef } from '../fasades/apiref';

export function createTrainStreamingChunk() : ParameterType
{
    const performanceType = ApiRef.getType("TrainPerformance");
    const usageType = ApiRef.getType("TrainUsage");

    const desc = (<>
        <h3>Train Streaming Chunk</h3>
        <p>When streaming is enabled for training, the response is sent as a series of chunks. Each chunk represents a different part of the training process:</p>
        <ul>
            <li><strong>Info chunks</strong> - Status messages during model loading (e.g., "Loading model", "Loading tokenizer")</li>
            <li><strong>Performance chunks</strong> - Metrics for each training step and sample, including accuracy, advantage, loss, and step number</li>
            <li><strong>Usage chunks</strong> - Final chunk containing usage statistics for the training operation</li>
            <li><strong>Error chunks</strong> - Error messages when something goes wrong during training</li>
        </ul>
        </>);

    return {
        id          : "TrainStreamingChunk",
        name        : "TrainStreamingChunk",
        description : desc,
        type        : Type.Object,
        parameters  : [
            {
                "name"        : "type",
                "type"        : "string",
                "description" : <p>The type of chunk. Can be "info", "performance", "usage", or "error".</p>,
                "optional"    : false
            },
            {
                "name"        : "message",
                "type"        : "string",
                "description" : <p>Present in info and error chunks. Contains status messages during model loading (info chunks) or error messages (error chunks).</p>,
                "optional"    : true
            },
            {
                "name"        : "performance",
                "type"        : "TrainPerformance",
                "description" : <><p>Present in performance chunks. Contains performance metrics for a training step and sample.</p>{ performanceType.description }</>,
                "optional"    : true
            },
            {
                "name"        : "usage",
                "type"        : "TrainUsage",
                "description" : <><p>Present in usage chunks. Contains usage statistics for the training operation.</p>{ usageType.description }</>,
                "optional"    : true
            }
        ]
    };
}

export function createTrainStreamingChunks() : ParameterType
{
    const childType = ApiRef.getType("TrainStreamingChunk");

    const desc = (<>
        <p>When streaming is enabled (stream: true), the response is returned as an array of chunks sent incrementally. Each chunk is a JSON object representing a different part of the training process.</p>
        <p>The chunks are sent in the following order:</p>
        <ol>
            <li>Info chunks (during model loading)</li>
            <li>Performance chunks (for each training step and sample)</li>
            <li>Usage chunk (when training completes)</li>
        </ol>
        </>);

    return {
        id          : "TrainStreamingChunk[]",
        name        : "TrainStreamingChunks",
        description : desc,
        type        : Type.Array,
        childType   : childType
    };
}

